/**
 * Re-export useAI hook from context for convenience
 */
export { useAI } from '@/context/AIContext'

